import constant from 'utils/values/constant.util';

const TIME_OFF_COLORS = constant([
  {
    id: 1,
    name: 'Light Grey',
    hex: '#BEBEBE',
  },
  {
    id: 2,
    name: 'Dark Grey',
    hex: '#535353',
  },
  {
    id: 3,
    name: 'Soft Black',
    hex: '#252629',
  },
  {
    id: 4,
    name: 'Light Purple',
    hex: '#EDD9FF',
  },
  {
    id: 5,
    name: 'Purple',
    hex: '#AF6DD1',
  },
  {
    id: 6,
    name: 'Dark Purple',
    hex: '#5F1C81',
  },
  {
    id: 7,
    name: 'Light Green',
    hex: '#B8E986',
  },
  {
    id: 8,
    name: 'Green',
    hex: '#4E9201',
  },
  {
    id: 9,
    name: 'Light Blue',
    hex: '#74A6FA',
  },
  {
    id: 10,
    name: 'Blue',
    hex: '#3C78FD',
  },
  {
    id: 11,
    name: 'Matte Blue',
    hex: '#3B5998',
  },
  {
    id: 12,
    name: 'Navy Blue',
    hex: '#002474',
  },
  {
    id: 13,
    name: 'Yellow',
    hex: '#FFF362',
  },
  {
    id: 14,
    name: 'Orange',
    hex: '#FA9F1D',
  },
  {
    id: 15,
    name: 'Light Pink',
    hex: '#CB91FF',
  },
  {
    id: 16,
    name: 'Red',
    hex: '#E32E45',
  },
  {
    id: 17,
    name: 'Deep Red',
    hex: '#9E034C',
  },
  {
    id: 18,
    name: 'Dark Red',
    hex: '#7F033E',
  },
]);

export default TIME_OFF_COLORS;
